import { SR_API_ACTION_HOUSEHOLD_GET_BY_USER_PHONE } from 'api/actionTypes';

export default async function getHouseholdByUserPhone({ state, apiClient }, phone) {
  const result = await apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_GET_BY_USER_PHONE,
    state: state,
    payload: {
      phone: phone,
    },
    onSuccess(household) {
      state.set(['admin', 'userHouseholdId'], household ? household.id : null);
      return household;
    },
  });

  return result;
}
